import React from "react";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { ArrowLeft, ReceiptText } from "lucide-react";

export default function RefundPolicy() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col bg-cream" data-testid="refund-policy-page">
      <Navbar />
      <main className="section flex-1">
        <div className="container-app max-w-3xl">
          <Link to="/" className="fx-btn fx-btn--ghost text-sm mb-4 inline-flex" data-testid="back-home">
            <ArrowLeft size={14} /> {t("common.backHome")}
          </Link>
          <div className="flex items-center gap-2 mb-2">
            <ReceiptText className="text-hive-ink" />
            <h1 className="font-display text-4xl md:text-5xl font-extrabold text-worker">{t("legal.refund.title")}</h1>
          </div>
          <p className="text-smoke">{t("legal.effective")}</p>

          <div className="card-base p-4 mt-6 bg-linen border-sand">
            <p className="text-sm text-worker"><Trans i18nKey="legal.draftBadge" components={{ strong: <strong />, em: <em /> }} /></p>
          </div>

          <section className="mt-8 space-y-6 text-worker">
            <Block title={t("legal.refund.s1Title")}>{t("legal.refund.s1Body")}</Block>
            <Block title={t("legal.refund.s2Title")}>{t("legal.refund.s2Body")}</Block>
            <Block title={t("legal.refund.s3Title")}>{t("legal.refund.s3Body")}</Block>
            <Block title={t("legal.refund.s4Title")}>{t("legal.refund.s4Body")}</Block>
            <Block title={t("legal.refund.s5Title")}>{t("legal.refund.s5Body")}</Block>
            <Block title={t("legal.refund.s6Title")}>{t("legal.refund.s6Body")}</Block>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function Block({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-xl font-bold text-worker mb-1">{title}</h2>
      <div className="text-sm text-worker/90 leading-relaxed">{children}</div>
    </div>
  );
}
